<div class="spinner-container" *ngIf="this.loadingService.loading$ | async">
  <i class="fa fa-refresh fa-spin spinner-orange" aria-hidden="true"></i>
  <span class="loading-text">{{ loadingMessage }}</span>
</div>
